<template>
  <div class="main about">
    <div class="banner"></div>
    <div class="mainContent">
      <div class="left">
        <div class="tab">
          <a href="javascript:;" @click="scrollToAnchor($event, 'aboutus')">About Us</a>
        </div>
        <div class="tab">
          <a href="javascript:;" @click="scrollToAnchor($event, 'location')">Location</a>
        </div>
        <div class="tab">
          <a href="javascript:;" @click="scrollToAnchor($event, 'contactus')">Contact Us</a>
        </div>
      </div>
      <div class="right">
        <div id="aboutus" class="aboutus">
          <h2 class="title">Team Introduction</h2>
          <p class="content">"Crait Team is headquartered in Chicago, Illinois. Crait Team dedicates to providing the safest mobile communication service to various companies, NGO, organizations and groups.  Crait is built to provide efficiency and security for your work.We will continue to offer a number of new features. With those features, Crait will provide more efficiency and security for your organiztions. "</p>
        </div>
        <div id="location" content="location">
          <h2  class="title">Location</h2>
          <img src='../assets/images/about_map@2x.png' alt=""/>
        </div>
        <div id="contactus" class="contactus">
          <div class="americanAddress">
            <h3>Contact Us</h3>
            <!--<p class="content">Add：1701 E Woodfield RD., STE 315, Schaumburg, IL60173, Chicago,US</p>-->
            <p class="content">E-mail：info@craitcorp.com</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    scrollToAnchor (e, anchorName) {
      let tab = document.getElementsByClassName('tab')
      for (let i = 0; i < tab.length; i++) {
        tab[i].childNodes[0].setAttribute('class', '')
      }
      if (anchorName) {
        let anchorElement = document.getElementById(anchorName)
        if (anchorElement) {
          anchorElement.scrollIntoView()
          document.body.scrollTop = anchorElement.offsetTop - 100
          e.target.setAttribute('class', 'active')
        }
      }
    }
  }
}
</script>

<style lang="scss">
.about {
  width: 100%;
  .banner {
    /*background:url('../assets/images/about_banner.png') center center no-repeat;*/
    background-size:cover;
    width: 100%;
    height: 1.6rem;
    @media screen and (max-width: 760px) {
      height: .8rem;
    }
  }
  .mainContent {
    width: 10rem;
    margin: 0 auto 2rem;
    padding-top: 0.4rem;
    &::after {
      content: '';
      display: table;
      overflow: hidden;
      clear: both;
    }
    .left {
      position: fixed;
      width: 1.6rem;
      .tab {
        text-align: right;

        a {
          font-size: 0.18rem;
          line-height: 0.3rem;
          color: #888;
          text-decoration: none;
        }

        .active {
          font-size: 0.24rem;
          color:#00A7FF;
        }
      }
    }
    .right {
      float: right;
      width: 7.5rem;
      color: #888;

      .aboutus {
        margin-bottom: 0.66rem;
      }

      img {
        margin: 0.3rem auto;
      }

      .title {
        font-size: 0.24rem;
        line-height: 0.24rem;
        margin-bottom: 0.2rem;
        font-weight: 400;
      }

      .content {
        font-size: 0.16rem;
        line-height: 0.24rem;
      }

      h3 {
        font-size: 0.24rem;
      }

      img {
        width: 100%;
      }
    }

    @media screen and (max-width: 1024px) {
      margin-bottom: 0.5rem;
      padding-top: .3rem;
      width: 7.2rem;

      .left {
        width: 1.4rem;

        a {
          font-size: 1.4rem;
        }

        .active {
          font-size: 1.8rem;
        }
      }

      .right {
        width: 5.6rem;

        .aboutus,.contactus {
          margin-bottom: 0.45rem;
        }

        .title {
          font-size: 0.3rem;
          line-height: 0.3rem;
          margin-bottom: 0.15rem;
        }

        .content {
          font-size: 0.12rem;
          line-height: 0.18rem;
        }

        h3 {
          font-size: 0.18rem;
        }
      }
    }
    @media screen and (max-width: 760px) {
      margin-bottom: 0.5rem;
      padding-top: 0.15rem;
      width: 90%;
      .left {
        display: none;
      }
      .right {
        width: 100%;
        .aboutus,.contactus {
          margin-bottom: 0.2rem;
        }
        .title {
          font-size: 0.24rem;
          line-height: 0.24rem;
          margin-bottom: 0.1rem;
        }
        .content {
          font-size: 0.12rem;
          line-height: 0.18rem;
        }
        h3 {
          font-size: 0.14rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// About.vue?5badb723